import {cva, type VariantProps} from 'class-variance-authority'

export const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold leading-4 transition-colors',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        destructive: 'border-transparent bg-destructive text-destructive-foreground',
        outline: 'border-border text-foreground',
        success: 'border-transparent bg-[var(--status-success)] text-white',
        warning: 'border-transparent bg-[var(--status-warning)] text-white',
      },
    },
    defaultVariants: {variant: 'default'},
  },
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
